import axios from 'axios';
import notify from '../utils/notify';

export function registerHttpErrorInterceptor(vuesaxInstance) {
  axios.interceptors.response.use(
    response => response,
    error => {
      const status = error && error.response && error.response.status;

      if (status === 401 || status === 403) {
        notify.notifyFail(
          vuesaxInstance,
          'Você não tem permissão para executar esta ação',
        );
      }

      return Promise.reject(error);
    },
  );
}
